module.exports = __webpack_public_path__ + "static/media/icon-why.png";